import React from 'react';
import {DatePicker} from 'antd';
import moment from 'moment';
import Toast from "../../utils/Toast";
import {Redirect} from 'react-router';
import HttpClient from '../../utils/HttpClient';
import ErrorAlert from '../../utils/ErrorAlert';
import GoogleAnalyticsPropertySelect from "../../utils/GoogleAnalyticsPropertySelect";
import {
    loadStateFromLocalStorage,
    removeStateFromLocalStorage,
    saveStateToLocalStorage
} from '../../helpers/CommonFunctions';
import AntdCategorySelect from "@/utils/AntdCategorySelect";
import TooltipInput from "@/components/annotations/TooltipInput";

const {RangePicker} = DatePicker;

const categoryServiceName = [
    "Holidays",
    "Google Updates",
    "Retail Marketing Dates",
    "Weather Alerts",
    "Website Monitoring",
    "Wordpress Updates",
    "WordPress Update",
    "News Alerts",
    "Google Ads",
    "Keyword Tracking",
    "Facebook",
    "Instagram",
    "Bitbucket tracking",
    "Github",
    "Twitter",
    "Wordpress",
    "Shopify",
    "Apple Podcast",
    "Youtube",
    "Tiktok",
    "GTM",
    "Website Design Changes",
    "Blog Changes",
    "Price Changes",
    "Competitor Website Changes"
]

export default class CreateAnnotation extends React.Component {
    constructor(props) {
        super(props);
        // const today = moment();
        this.state = {
            annotation: {
                category: '',
                categoryColor: '',
                event_name: '',
                url: '',
                description: '',
                document: '',
                show_at: [],
                google_analytics_property_id: [""]
            },
            categories: [],
            automationTooltips: [],
            validation: {},
            resp: '',
            error: '',
            categoryColor: '',
            isBusy: false,
            isDirty: false,
            allPropertiesAllowed: true,
            redirectTo: null,
            selectedFile: null,
            fileName: '',
            user: null,
            userAnnotationColors: {},
        }
        this.changeHandler = this.changeHandler.bind(this)
        this.submitHandler = this.submitHandler.bind(this)
        this.setDefaultState = this.setDefaultState.bind(this)
        this.loadCategoriesList = this.loadCategoriesList.bind(this)
        this.loadUserAnnotationColors = this.loadUserAnnotationColors.bind(this);
        this.checkIfCanCreateAnnotation = this.checkIfCanCreateAnnotation.bind(this)
        this.updateUserAnnotationColors = this.updateUserAnnotationColors.bind(this);
        this.handleFileChange = this.handleFileChange.bind(this);
        this.getAnalyticsProperties = this.getAnalyticsProperties.bind(this);
        this.loadInitialData = this.loadInitialData.bind(this);
    }

    checkIfCanCreateAnnotation() {
        HttpClient.get('user')
            .then(user_response => {
                this.setState({
                    user: user_response.data.user
                })
                HttpClient.get('user_total_annotations')
                    .then(response => {
                        let cu = user_response.data.user;
                        if (cu.price_plan.code == "free new" || cu.price_plan.code == "Trial") {
                            if (cu.price_plan.annotations_count == 0) {
                                // unlimited
                            } else {
                                if (response.data.user_total_annotations >= cu.price_plan.annotations_count) {
                                    this.props.upgradePopup('more-annotations')
                                }
                            }

                        }
                    });
            });
    }

    componentDidMount() {
        const savedState = loadStateFromLocalStorage("CreateAnnotation");
        if (savedState && savedState.annotation) {
            this.setState(prevState => ({
                annotation: {
                    ...prevState.annotation,
                    ...savedState.annotation,
                    show_at: []
                }
            }));
        }
        if (this.props.currentPricePlan.name == "Trial Ended") {
            removeStateFromLocalStorage("CreateAnnotation");
            this.props.togglePopup('');
            this.props.upgradePopup('more-annotations')
            // this.setState({redirectTo: "/settings/price-plans"});
        }
        this.loadCategoriesList();
        this.loadInitialData();
        this.loadUserAnnotationColors();
        this.checkIfCanCreateAnnotation();
        this.getAnalyticsProperties();
    }

    loadUserAnnotationColors() {
        HttpClient.get(`/data-source/user-annotation-color`).then(resp => {
            this.setState({isLoading: false, userAnnotationColors: resp.data.user_annotation_color});
        }, (err) => {
            this.setState({isLoading: false, errors: (err.response).data});
        }).catch(err => {
            this.setState({isLoading: false, errors: err});
        })

    }

    loadInitialData = async () => {
        const {data} = await HttpClient.get(`/automation-tooltips`)
        this.setState({automationTooltips: data});
    }

    loadCategoriesList() {
        this.setState({isBusy: true})
        HttpClient.get(`/annotation-categories`)
            .then(response => {
                this.setState({
                    isBusy: false, categories: response.data.categories.map(c => {
                        return {label: c.category, value: c.category}
                    })
                });
            }, (err) => {

                this.setState({isBusy: false, errors: (err.response).data});
            }).catch(err => {

            this.setState({isBusy: false, errors: err});
        });
    }

    setDefaultState() {
        // const today = moment();
        this.setState({
            annotation: {
                category: '',
                event_name: '',
                url: '',
                description: '',
                show_at: [],
                document: null,
                google_analytics_property_id: [""]
            },
            validation: {},
            resp: '',
            error: '',
            categoryColor: '',
            isBusy: false,
            isDirty: false,
            errors: undefined
        });
    }

    changeHandler(e) {
        if (e?.target?.name) {
            let errors = this.state.validation || {};
            delete errors[e.target.name];
            this.setState({
                    validation: errors,
                    isDirty: true,
                    annotation: {
                        ...this.state.annotation,
                        [e.target.name]: e.target.value,
                        ...(e.target.color ? {categoryColor: e.target.color} : {})
                    }
                },
                () => {
                    setTimeout(() => {
                        saveStateToLocalStorage("CreateAnnotation", {annotation: this.state.annotation});
                    }, 500);
                });

            if (e?.target?.name === 'category' && e.target.color) {
                HttpClient.post(`/annotation-categories`, {
                    name: e.target.value,
                    color: e.target.color,
                    allowNew: categoryServiceName.indexOf(e.target.value) > -1
                })
                    .then(response => {

                        this.props.onColorChangeRandomKey(`${e.target.value}-${e.target.color}`)
                        // this.setState({
                        //     isBusy: false, categories: response.data.categories.map(c => {
                        //         return {label: c.category, value: c.category}
                        //     })
                        // });
                    }, (err) => {
                        console.log("=>(CreateAnnotation.js:190) err", err);

                        // this.setState({isBusy: false, errors: (err.response).data});
                    }).catch(err => {
                    console.log("=>(CreateAnnotation.js:190) err", err);

                    // this.setState({isBusy: false, errors: err});
                });
            }
        } else if (Array.isArray(e)) {
            // Handle date range picker change
            this.setState(prevState => ({
                annotation: {
                    ...prevState.annotation,
                    show_at: e.length ? e : []
                },
                isDirty: true
            }), () => {
                saveStateToLocalStorage("CreateAnnotation", {annotation: this.state.annotation});
            });
        }
    }

    handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            this.setState({selectedFile: file, fileName: file.name});
        }
    };
    submitHandler = async (e) => {
        e.preventDefault();

        if (this.validate() && !this.state.isBusy) {
            this.setState({isBusy: true});

            const {show_at, ...restAnnotation} = this.state.annotation;
            const selectedProperties = this.state.annotation.google_analytics_property_id;

            if (!this.state.allPropertiesAllowed && !selectedProperties.length) {
                this.setState({
                    isBusy: false,
                    errors: {message: 'Please select the property before creating annotation'}
                });
                return false;
            }

            try {
                const [startDate, endDate] = show_at;
                let currentDate = moment(startDate ? startDate.format() : new Date());
                const lastDate = moment(endDate ? endDate.format() : new Date());

                while (currentDate.isSameOrBefore(lastDate)) {
                    let fd = new FormData();
                    for (let key in restAnnotation) {
                        if (key !== 'google_analytics_property_id') {
                            fd.append(key, restAnnotation[key]);
                        }
                    }
                    fd.append('show_at', currentDate.format('YYYY-MM-DD'));
                    selectedProperties.forEach((gAA) => {
                        fd.append('google_analytics_property_id[]', gAA);
                    });
                    if (this.state.selectedFile) {
                        fd.append('document', this.state.selectedFile);
                    }

                    await HttpClient.post('/annotation', fd);
                    currentDate = currentDate.add(1, 'days');
                }

                localStorage.setItem(`annotation_saved_need_to_refetch`, 'yes');
                removeStateFromLocalStorage("CreateAnnotation");
                Toast.fire({
                    icon: 'success',
                    title: "Annotations added for the selected date range."
                });
                this.props.togglePopup('');
                this.setState({isBusy: false});
                this.setState({redirectTo: "/annotation"});
            } catch (err) {
                if (err.response && err.response.status == 402) {
                    this.props.upgradePopup('increase-limits');
                } else {
                    this.setState({
                        isBusy: false,
                        errors: err.response ? err.response.data : {message: 'An unexpected error occurred'}
                    });
                }
                this.loadCategoriesList();
            }
        }
    }

    validate() {
        let category = this.state.annotation.category;
        let event_name = this.state.annotation.event_name;
        let url = this.state.annotation.url;
        let description = this.state.annotation.description;
        let show_at = this.state.annotation.show_at;
        let document = this.state.annotation.document;


        let errors = {};
        let isValid = true;

        if (!category) {
            isValid = false;
            errors["category"] = "Please select category.";
        }

        if (!event_name) {
            isValid = false;
            errors["event_name"] = "Please enter your event name.";
        }

        // if (!show_at) {
        //     isValid = false;
        //     errors["show_at"] = "Please add show_at date.";
        // }


        this.setState({
            validation: errors
        });

        return isValid;
    }

    updateUserAnnotationColors(userAnnotationColors) {
        this.setState({userAnnotationColors: userAnnotationColors});
    }

    async getAnalyticsProperties() {
        const response = await HttpClient.get('settings/google-analytics-property?keyword=');
        let hasLimitedAccess = response.data.is_allowed_access_to_all_properties;
        this.setState({allPropertiesAllowed: hasLimitedAccess});
    }

    render() {
        if (this.state.redirectTo) return <Redirect to={this.state.redirectTo}/>;

        const validation = this.state.validation;
        console.log(`"=>(CreateAnnotation.js:304) loadStateFromLocalStorage("CreateAnnotation")?.show_at"`, loadStateFromLocalStorage("CreateAnnotation")?.annotation?.show_at);
        return (
            <div className="popupContent modal-createAnnotation">
                <div className="apps-bodyContent">
                    <form onSubmit={this.submitHandler} enctype="multipart/form-data" id="annotation-create-form">
                        <ErrorAlert errors={this.state.errors}/>
                        <div className='grid2layout'>
                            <div className="themeNewInputStyle">
                                <TooltipInput
                                    value={this.state.annotation.event_name}
                                    onChange={this.changeHandler}
                                    automationTooltips={this.state.automationTooltips}
                                    placeholder="Event name *"
                                    className="form-control"
                                    name="event_name"
                                    id="event_name"
                                />
                                {validation.event_name ? <span
                                    className="bmd-help text-danger"> &nbsp; &nbsp;{validation.event_name}</span> : ''}
                            </div>
                            <div className="themeNewInputStyle">
                                <AntdCategorySelect
                                    className="gray_clr"
                                    name="category"
                                    id="category"
                                    value={this.state.annotation.category}
                                    categories={this.state.categories}
                                    onChangeCallback={this.changeHandler}
                                    placeholder="Type to add or search a category"/>
                                {validation.category ? <span
                                    className="bmd-help text-danger"> &nbsp; &nbsp;{validation.category}</span> : ''}
                            </div>
                        </div>

                        <div className="themeNewInputStyle has-danger mb-3">
                            <TooltipInput
                                value={this.state.annotation.description}
                                onChange={this.changeHandler}
                                automationTooltips={this.state.automationTooltips}
                                placeholder="Description"
                                className="form-control"
                                name="description"
                                id="description"
                            />
                            {validation.description ? <span
                                className="bmd-help text-danger"> &nbsp; &nbsp;{validation.description}</span> : ''}
                        </div>

                        <div className='grid2layout'>
                            <div className="themeNewInputStyle position-relative inputWithIcon">
                                <i className="icon fa"><img src='/icon-chain-gray.svg'/></i>
                                <input type="text" autocomplete="off" value={this.state.annotation.url}
                                       onChange={this.changeHandler}
                                       className="form-control" id="url" name="url" placeholder='https://'/>
                                {validation.url ?
                                    <span className="bmd-help text-danger"> &nbsp; &nbsp;{validation.url}</span> : ''}
                            </div>

                            <div className="themeNewInputStyle">
                                <RangePicker
                                    name="show_at"
                                    className="w-full"
                                    size="large"
                                    onChange={this.changeHandler}
                                    value={this.state.show_at}
                                    placeholder={['Start date', 'End date']}
                                    allowEmpty={[true, true]}
                                />
                                {validation.show_at &&
                                    <span className="bmd-help text-danger"> &nbsp; &nbsp;{validation.show_at}</span>}
                            </div>
                        </div>
                        <div className='grid2layout'>
                            <div className="themeNewInputStyle">
                                <GoogleAnalyticsPropertySelect
                                    name="google_analytics_property_id"
                                    id="google_analytics_property_id"
                                    className="gray_clr"
                                    value={this.state.annotation.google_analytics_property_id}
                                    onChangeCallback={this.changeHandler}
                                    placeholder="Assign annotation to"
                                    components={{
                                        DropdownIndicator: () => null,
                                        IndicatorSeparator: () => null
                                    }}
                                    multiple
                                    currentPricePlan={this.props.currentPricePlan}
                                />
                            </div>
                            <div className="themeNewInputStyle">
                                <div>
                                    <div className="themeNewInputGroup inputFile">
                                        <label style={{padding: '2px 6px 2px 6px'}}>
                                            <span><i><img style={{width: 15}} src={'/icon-paperclip.svg'}
                                                          alt={'Paper Clip icon'} className="svg-inject"/></i>
                                                {this.state.selectedFile ?
                                                    <span className="truncate w-[125px]">{this.state.fileName}</span>
                                                    :
                                                    <span>No file chosen...</span>
                                                }
                                            </span>
                                            <label htmlFor="document" className="form-control-placeholder">Upload
                                                <input type="file" id="document" onChange={this.handleFileChange}
                                                       name="document"/>
                                            </label>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='d-flex pt-3'>
                            <button type="submit" className="btn-theme"
                                    title="submit">{this.state.isBusy ? 'Loading...' : 'Add'}</button>
                        </div>
                    </form>
                </div>
            </div>
        )
    }

}
